<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.email != '', 'has-danger' : validation.email != '' }">
                                        <label for="email" class="bmd-label-floating">E-mail *</label>
                                        <input refs="email" type="text" class="form-control" v-model="form.email" />
                                        <label v-if="validation.email != ''" id="email-error" class="error" for="email">{{ validation.email }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div
                                        class="form-group bmd-form-group"
                                        v-bind:class="{'is-filled': form.code != '', 'has-danger' : validation.code != '' }"
                                    >
                                        <label for="code" class="bmd-label-floating">Código</label>
                                        <input refs="code" type="text" class="form-control" v-model="form.code">
                                        <label
                                        v-if="validation.code != ''"
                                        id="code-error"
                                        class="error"
                                        for="code"
                                        >{{ validation.code }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.profile_id != '', 'has-danger' : validation.profile_id != '' }">
                                        <model-list-select 
                                            class="form-control"
                                            :list="profiles"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.profile_id"
                                            :placeholder="form.profile?form.profile.name:''">
                                        </model-list-select>
                                        <label v-if="validation.profile_id != ''" id="profile_id-error" class="error" for="profile_id">{{ validation.profile_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.username != '', 'has-danger' : validation.username != '' }">
                                        <label for="username" class="bmd-label-floating">Login *</label>
                                        <input refs="username" type="text" class="form-control" v-model="form.username" />
                                        <label v-if="validation.username != ''" id="username-error" class="error" for="username">{{ validation.username }}</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.password != '', 'has-danger' : validation.password != '' }">
                                        <label for="password" class="bmd-label-floating">Senha</label>
                                        <input refs="password" type="password" class="form-control" v-model="form.password" />
                                        <label v-if="validation.password != ''" id="password-error" class="error" for="password">{{ validation.password }}</label>
                                        <label v-if="validation.password == ''" id="password-info" for="password">Preencher para trocar a senha!</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.password_confirmation != '', 'has-danger' : validation.password_confirmation != '' }">
                                        <label for="password_confirmation" class="bmd-label-floating">Confirmação de Senha</label>
                                        <input refs="password_confirmation" type="password" class="form-control" v-model="form.password_confirmation" />
                                        <label v-if="validation.password_confirmation != ''" id="password_confirmation-error" class="error" for="password_confirmation">{{ validation.password_confirmation }}</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.branch_id != '', 'has-danger' : validation.branch_id != '' }">
                                        <model-list-select 
                                            class="form-control"
                                            :list="branches"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.branch_id"
                                            :placeholder="form.branch?form.branch.name:''">
                                        </model-list-select>
                                        <label v-if="validation.branch_id != ''" id="branch_id-error" class="error" for="branch_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                <hr />
                                </div>
                            </div>
                            <h5>Logins em integrações</h5>
                            <div class="row">
                                <div class="col-md-3">
                                <div
                                    class="form-group bmd-form-group"
                                    v-bind:class="{'is-filled': form.user_gmac != ''}">
                                    <label for="user_gmac" class="bmd-label-floating">Usuário na GMAC</label>
                                    <input refs="user_gmac" type="text" class="form-control" v-model="form.user_gmac">
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'users.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ActionService from '@/services/modules/actions.service';
    import TypeProfileService from '@/services/modules/typeprofiles.service';
    import validation from '@/services/validations.service';

    export default {
        data() {
            return {
                branches: [],
                form: {
                    name: '',
                    username: '',
                    profile_id: '',
                    branch_id: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    user_gmac: ""
                },
                profiles: [],
                validation: {
                    code: '',
                    name: '',
                    username: '',
                    profile_id: '',
                    branch_id: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                }
            };
        },
        created() {
            var self = this;

            self.getDataProfiles();
        },
        methods: {
            async getData() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('users/get', this.$route.params.id);

                response.then(function (_data) {
                    self.$root.$emit("onLoading");

                    self.form = _data;
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.danger("Falha na consulta a API!");
                    self.$router.push({'name': 'users.index'});
                });
            },
            async getDataBranch() {
                var self = this;
                
                self.$root.$emit('onLoading');
                
                const response =  this.$store.dispatch('branches/all');
                
                response.then(function(_branches){
                    self.branches = _branches;
                    self.branches.unshift({id: '', name: 'Escolha uma Empresa'});
                    self.$root.$emit('onLoading');
                    self.getData();
                });
                
                response.catch(function(){
                    self.$root.$emit('onLoading');
                });
            },
            async getDataProfiles() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = this.$store.dispatch('profiles/all');

                response.then(function (_profiles) {
                    self.profiles = _profiles;
                    self.profiles.unshift({id: '', name: 'Escolha um Perfil'});
                    self.getDataBranch();
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.name = '';
                self.validation.email = '';
                self.validation.profile_id = '';
                self.validation.username = '';
                self.validation.password = '';
                self.validation.password_confirmation = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (!validation.mail(self.form.email)) {
                    self.validation.email = 'E-mail inválido!';
                    valid = false;
                }

                if (self.form.username == '') {
                    self.validation.username = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.profile_id == '') {
                    self.validation.profile_id = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.password != '') {
                    if (validation.password(self.form.password) < 30) {
                        self.validation.password = 'Campo obrgiatório!';
                        valid = false;
                    }

                    if (self.form.password != self.form.password_confirmation) {
                        self.validation.password_confirmation = 'Confirmação senha incorreta!';
                        valid = false;
                    }
                }

                if (valid) {
                    self.$root.$emit("onLoading");
                    const response = self.$store.dispatch('users/edit', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Usuário atualizado com sucesso!");
                        self.$router.push({'name': 'users.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 406) {
                            if (err.data.name !== undefined) {
                                self.validation.name = err.data.name[0];
                            }

                            if (err.data.email !== undefined) {
                                self.validation.email = err.data.email[0];
                            }

                            if (err.data.username !== undefined) {
                                self.validation.username = err.data.username[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>
<style scoped>
    .card-title {
        color: #3c4858;
        text-decoration: none;
    }
</style>